export const formatNumber = (num) => {
	const formatter = new Intl.NumberFormat('en-US', {
		style: 'decimal',
		minimumFractionDigits: 0,
		maximumFractionDigits: 2,
	});
	return formatter.format(num);
};


/**
 * Function to calculate the average daily increase
 * @param {Array} data - Array of objects with date and points fields
 * @returns {number} - Average daily increase
 */
export const calculateAverageDailyIncrease = (data) => {
	if (data.length < 2) {
		// throw new Error('Not enough data to calculate');
		return 0;
	}

	let totalIncrease = 0;
	let totalDays = 0;

	for (let i = 1; i < data.length; i++) {
		const previous = data[i - 1];
		const current = data[i];

		// Skip duplicate dates
		if (new Date(current.date).getTime() === new Date(previous.date).getTime()) {
			continue;
		}

		// Calculate the difference in points
		const pointsDifference = current.points - previous.points;

		// Calculate the difference in days
		const dateDifference = new Date(current.date) - new Date(previous.date);
		const daysDifference = dateDifference / (1000 * 60 * 60 * 24); // Convert to days

		// Ensure we do not divide by zero
		if (daysDifference !== 0) {
			totalIncrease += pointsDifference / daysDifference;
			totalDays += 1;
		}
	}

	if (totalDays === 0) {
		throw new Error('No valid days to calculate the average');
	}

	return totalIncrease / totalDays;
};


export async function estimateBlockCountdown(
	currentBlockNumber,
	targetBlockNumber
) {
	const averageBlockTime = 3;
	const blockDifference = targetBlockNumber - currentBlockNumber;

	const estimatedTimeSeconds = blockDifference * averageBlockTime;

	const days = Math.floor(estimatedTimeSeconds / (60 * 60 * 24));
	const hours = Math.floor((estimatedTimeSeconds % (60 * 60 * 24)) / (60 * 60));
	const minutes = Math.floor((estimatedTimeSeconds % (60 * 60)) / 60);
	const seconds = estimatedTimeSeconds % 60;

	console.log(`Current Block: ${currentBlockNumber}`);
	console.log(`Target Block: ${targetBlockNumber}`);
	console.log(`Block Difference: ${blockDifference}`);
	console.log(
		`Estimated Time: ${days} days, ${hours} hours, ${minutes} minutes, and ${seconds} seconds`
	);

	return {
		days,
		hours,
		minutes,
		seconds,
		totalSeconds: estimatedTimeSeconds,
	};
}
